import { render, staticRenderFns } from "./SendLead.vue?vue&type=template&id=454cd622"
import script from "./SendLead.vue?vue&type=script&lang=js"
export * from "./SendLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports